import React from 'react';
import I18n from 'i18n-js';
import ButtonWithTooltip from '@/components/shared/LessonOverview/Cards/ActionBar/ButtonWithTooltip';
import { twMerge } from '@/utils';
import Icon from '@/components/ui/Icon';

type AvailableActions = 'view' | 'edit' | 'copy' | 'print' | 'delete';

const ICON_SIZE = 16;

const actionProps = {
  copy: {
    ariaLabel: I18n.t('make_a_copy'),
    icon: (<Icon icon="Copy" size={18} tabIndex={-1} />),
    tooltipContent: I18n.t('make_a_copy'),
  },
  delete: {
    ariaLabel: I18n.t('delete'),
    icon: (<Icon icon="Delete" size={ICON_SIZE} tabIndex={-1} />),
    tooltipContent: I18n.t('delete'),
  },
  edit: {
    ariaLabel: I18n.t('edit'),
    icon: (<Icon icon="EditPreview" size={ICON_SIZE} tabIndex={-1} />),
    tooltipContent: I18n.t('edit'),
  },
  print: {
    ariaLabel: I18n.t('print'),
    icon: (<Icon icon="Print" size={ICON_SIZE} tabIndex={-1} />),
    tooltipContent: I18n.t('print'),
  },
  view: {
    ariaHidden: true,
    ariaLabel: I18n.t('view'),
    icon: (<Icon icon="Play" size={ICON_SIZE} tabIndex={-1} />),
    tooltipContent: I18n.t('view'),
  },
};

type Action = {
  [key in AvailableActions]?: string;
};

type ActionOption = {
  [key in AvailableActions]?: {
    ariaLabel?: string;
    dataMethod?: string;
    iconClassName?: string;
    openInNewWindow?: boolean;
    onClick?: Function;
    shouldNavigate?: boolean;
    tooltipContent?: string;
  }
};

export interface CardActionsProps {
  actionOptions?: ActionOption;
  actions: Action[];
  className?: string;
}

const CardActions = ({ actionOptions = {}, actions, className }: CardActionsProps) => (
  <div className={twMerge('tw-flex', className)}>
    {actions.map((actionObj) => {
      const action = Object.keys(actionObj)[0];
      const url = actionObj[action];

      return (
        <ButtonWithTooltip
          key={action}
          className="tw-box-border tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-text-[#777770] hover:!tw-text-tci-purple tw-cursor-pointer"
          link={url}
          {...actionProps[action]}
          {...actionOptions[action]}
          icon={undefined}
        >
          {actionProps[action].icon}
        </ButtonWithTooltip>
      );
    })}
  </div>
);

export default CardActions;
